var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicroPhoneDraftCampaign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 117,
    viewBox: "0 0 116 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone_9225928 1",
    clipPath: "url(#clip0_5360_33364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1937 116.5C12.1672 116.5 7.27344 111.606 7.27344 105.58V11.4203C7.27344 5.39375 12.1672 0.5 18.1937 0.5H62.8039C68.8305 0.5 73.7242 5.39375 73.7242 11.4203V105.602C73.7242 111.629 68.8305 116.523 62.8039 116.523H18.1937V116.5Z",
    fill: "url(#paint0_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4078 15.5438V0.5H18.1938C12.1672 0.5 7.27344 5.39375 7.27344 11.4203V15.5664H22.4078V15.5438Z",
    fill: "url(#paint1_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.5664 15.5438V0.5H62.7805C68.807 0.5 73.7008 5.39375 73.7008 11.4203V15.5664H58.5664V15.5438Z",
    fill: "url(#paint2_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.5664 101.456V116.5H62.7805C68.807 116.5 73.7008 111.606 73.7008 105.58V101.434H58.5664V101.456Z",
    fill: "url(#paint3_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.27344 105.059V105.58C7.27344 111.606 12.1672 116.5 18.1937 116.5H62.8039C68.8305 116.5 73.7242 111.606 73.7242 105.58V105.059H7.27344Z",
    fill: "url(#paint4_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.4078 101.456V116.5H18.1938C12.1672 116.5 7.27344 111.606 7.27344 105.58V101.434H22.4078V101.456Z",
    fill: "url(#paint5_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M67.6758 1.65625C71.2328 3.44609 73.7023 7.13906 73.7023 11.3984V105.58C73.7023 109.84 71.2555 113.533 67.6758 115.323V1.65625Z",
    fill: "url(#paint6_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.7016 11.9414V11.4203C73.7016 5.39375 68.8078 0.5 62.7813 0.5H18.1938C12.1672 0.5 7.27344 5.39375 7.27344 11.4203V11.9414H73.7016Z",
    fill: "url(#paint7_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.3 1.65625C9.74297 3.44609 7.27344 7.16172 7.27344 11.4211V105.603C7.27344 109.863 9.72031 113.555 13.3 115.345V1.65625Z",
    fill: "url(#paint8_linear_5360_33364)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M69.2148 105.583C69.2148 109.14 66.3375 111.995 62.8031 111.995H18.193C14.6359 111.995 11.7812 109.117 11.7812 105.583V11.4234C11.7812 7.86641 14.6586 5.01172 18.193 5.01172H62.8031C66.3602 5.01172 69.2148 7.88906 69.2148 11.4234V105.583Z",
    fill: "url(#paint9_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M62.8035 4.98828H59.541V112.016H62.7809C66.3379 112.016 69.1926 109.139 69.1926 105.605V11.4227C69.2152 7.86563 66.3379 4.98828 62.8035 4.98828Z",
    fill: "url(#paint10_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.7812 103.68V105.605C11.7812 109.162 14.6586 112.017 18.193 112.017H62.8031C66.3602 112.017 69.2148 109.14 69.2148 105.605V103.68H11.7812Z",
    fill: "url(#paint11_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.193 112.016H21.4328V4.98828H18.193C14.6359 4.98828 11.7812 7.86562 11.7812 11.4V105.582C11.7812 109.139 14.6359 112.016 18.193 112.016Z",
    fill: "url(#paint12_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M69.2148 15.0938V11.4234C69.2148 7.86641 66.3375 5.01172 62.8031 5.01172H18.193C14.6359 5.01172 11.7812 7.88906 11.7812 11.4234V15.0938H69.2148Z",
    fill: "url(#paint13_linear_5360_33364)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M51.2484 108.456H29.7477C28.9547 108.456 28.3203 107.822 28.3203 107.029C28.3203 106.236 28.9547 105.602 29.7477 105.602H51.2484C52.0414 105.602 52.6758 106.236 52.6758 107.029C52.6758 107.822 52.0414 108.456 51.2484 108.456Z",
    fill: "url(#paint14_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M29.7469 107.779C29.3164 107.779 28.9766 107.439 28.9766 107.009C28.9766 106.578 29.3164 106.238 29.7469 106.238H51.2477C51.6781 106.238 52.018 106.578 52.018 107.009C52.018 107.439 51.6781 107.779 51.2477 107.779H29.7469Z",
    fill: "url(#paint15_linear_5360_33364)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M48.0312 12.6445H32.9648C31.5148 12.6445 30.3594 11.4664 30.3594 10.0391C30.3594 8.58906 31.5375 7.43359 32.9648 7.43359H48.0312C49.4813 7.43359 50.6367 8.61172 50.6367 10.0391C50.6367 11.4891 49.4586 12.6445 48.0312 12.6445Z",
    fill: "url(#paint16_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M32.9641 11.9867C31.8992 11.9867 31.0156 11.1258 31.0156 10.0383C31.0156 8.97344 31.8766 8.08984 32.9641 8.08984H48.0305C49.0953 8.08984 49.9789 8.95078 49.9789 10.0383C49.9789 11.1031 49.118 11.9867 48.0305 11.9867H32.9641Z",
    fill: "url(#paint17_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M33.0559 11.4203C33.8191 11.4203 34.4379 10.8016 34.4379 10.0383C34.4379 9.27501 33.8191 8.65625 33.0559 8.65625C32.2926 8.65625 31.6738 9.27501 31.6738 10.0383C31.6738 10.8016 32.2926 11.4203 33.0559 11.4203Z",
    fill: "url(#paint18_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M33.0562 10.8977C33.5317 10.8977 33.9172 10.5122 33.9172 10.0367C33.9172 9.56124 33.5317 9.17578 33.0562 9.17578C32.5808 9.17578 32.1953 9.56124 32.1953 10.0367C32.1953 10.5122 32.5808 10.8977 33.0562 10.8977Z",
    fill: "url(#paint19_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M33.0559 10.1742C33.1309 10.1742 33.1918 10.1134 33.1918 10.0383C33.1918 9.9632 33.1309 9.90234 33.0559 9.90234C32.9808 9.90234 32.9199 9.9632 32.9199 10.0383C32.9199 10.1134 32.9808 10.1742 33.0559 10.1742Z",
    fill: "url(#paint20_linear_5360_33364)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M73.7238 32.2188L73.7012 45.7445H73.7238C74.1316 45.7445 74.4715 45.4047 74.4715 44.9969V32.9664C74.4715 32.5586 74.1316 32.2188 73.7238 32.2188Z",
    fill: "url(#paint21_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M7.27305 37.3836V29.9297C6.86523 29.9297 6.52539 30.2695 6.52539 30.6773V36.6133C6.52539 37.0438 6.86523 37.3836 7.27305 37.3836ZM7.27305 45.7438V38.2898C6.86523 38.2898 6.52539 38.6297 6.52539 39.0375V44.9734C6.52539 45.4039 6.86523 45.7438 7.27305 45.7438Z",
    fill: "url(#paint22_linear_5360_33364)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M61.1496 97.4242L58.4082 99.0555C57.9324 99.35 57.3207 99.1914 57.0262 98.7156L50.0254 86.9797C51.4301 87.1609 52.8801 86.8891 54.1941 86.1414C55.3043 85.507 56.1879 84.6008 56.7543 83.5586C57.0941 86.1641 58.227 90.3555 61.4895 96.0422C61.784 96.518 61.6254 97.1297 61.1496 97.4242Z",
    fill: "url(#paint23_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M106.12 42.4146C112.351 59.1802 109.655 75.6287 100.117 79.163C90.5783 82.6974 77.8228 71.981 71.5923 55.2154C65.3619 38.4498 68.058 22.0013 77.5962 18.4669C87.1345 14.9326 99.89 25.649 106.12 42.4146Z",
    fill: "url(#paint24_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M101.092 44.27C106.213 58.0676 104.899 71.2989 98.1472 73.8137C91.3956 76.3286 81.7667 67.1528 76.6237 53.3551C71.4808 39.5575 72.8175 26.3262 79.569 23.8114C86.3433 21.3192 95.9722 30.4723 101.092 44.27Z",
    fill: "url(#paint25_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M71.5941 55.2133C67.1308 43.1602 67.2441 31.2883 71.209 24.2422C71.1636 24.3102 71.1183 24.3781 71.073 24.4234C68.2183 28.6148 64.7746 32.4438 61.0363 35.8648C55.1683 41.1891 48.3261 45.1992 40.9175 48.0086C38.9238 48.7562 37.1793 49.6172 35.6386 51.1578C30.9261 55.9609 30.5183 63.5961 32.7613 69.6227C35.0043 75.6492 40.3058 81.1773 46.9894 81.7437C49.1644 81.925 51.0449 81.4266 53.0386 80.7016C60.4699 77.9828 68.2863 76.5555 76.1933 76.782C81.2683 76.918 86.366 77.575 91.2597 78.8891C91.3277 78.9117 91.4183 78.9344 91.4863 78.957C83.9191 76.193 76.0801 67.2664 71.5941 55.2133Z",
    fill: "url(#paint26_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M45.9472 64.7531C42.9566 56.7102 44.1347 48.5992 48.3715 44.6797C45.9699 45.9484 43.4777 47.0359 40.9175 48.0102C38.9238 48.7578 37.1793 49.6188 35.6386 51.182C30.9261 55.9852 30.5183 63.6203 32.7613 69.6469C35.0043 75.6734 40.3058 81.2016 46.9894 81.768C49.1644 81.9492 51.0449 81.4508 53.0386 80.7258C55.5988 79.7969 58.2043 79.0039 60.855 78.3922C55.123 78.1883 48.9379 72.7734 45.9472 64.7531Z",
    fill: "url(#paint27_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M75.218 46.4718C75.0141 46.5398 74.8328 46.6304 74.6289 46.721C75.1273 48.896 75.7844 51.1163 76.6227 53.382C77.4609 55.6249 78.4125 57.7546 79.4547 59.7257C79.6586 59.6804 79.8625 59.6124 80.0664 59.5218C83.6687 58.1851 85.5039 54.1749 84.1672 50.5726C82.8305 46.9703 78.8203 45.1351 75.218 46.4718Z",
    fill: "url(#paint28_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M31.469 63.1211L30.1776 63.5969C28.4784 64.2313 27.187 65.5 26.4847 67.018C25.7823 68.5359 25.669 70.3484 26.3034 72.0477C27.5722 75.4461 31.3558 77.1906 34.7542 75.9219L36.0456 75.4461C34.6409 73.7016 33.5308 71.7078 32.7831 69.6461C32.0128 67.5844 31.5597 65.3641 31.469 63.1211Z",
    fill: "url(#paint29_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M53.0602 80.7016C51.0437 81.4266 49.1633 81.925 47.0109 81.7438C44.9719 81.5625 43.0461 80.9281 41.3242 79.9766C42.8422 80.8148 44.0883 82.0383 44.9492 83.5336L44.9945 83.6016C46.8297 86.8414 50.9758 87.9742 54.2156 86.1391C55.9148 85.1648 57.025 83.5789 57.4555 81.8117C57.8633 80.1352 59.1094 78.7758 60.7859 78.3906C58.1578 79.0023 55.5977 79.7953 53.0602 80.7016Z",
    fill: "url(#paint30_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M36.0007 68.4483C35.6382 67.4515 36.1366 66.3186 37.1561 65.9561L40.6452 64.6647C41.6421 64.3022 42.7749 64.8007 43.1374 65.8202C43.4999 66.8171 43.0015 67.9499 41.9819 68.3124L38.4929 69.6038C37.496 69.9663 36.3632 69.4452 36.0007 68.4483Z",
    fill: "url(#paint31_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M34.6628 58.4327C34.3003 57.4358 34.7987 56.303 35.8183 55.9405L39.3073 54.6491C40.3042 54.2866 41.437 54.785 41.7995 55.8046C42.162 56.8015 41.6636 57.9343 40.644 58.2968L37.155 59.5882C36.1581 59.9507 35.0479 59.4296 34.6628 58.4327Z",
    fill: "url(#paint32_linear_5360_33364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M41.528 76.8976C41.1655 75.9007 41.664 74.7679 42.6835 74.4054L46.1725 73.114C47.1694 72.7515 48.3022 73.2499 48.6647 74.2694C49.0272 75.2663 48.5288 76.3991 47.5093 76.7616L44.0202 78.053C43.0233 78.4155 41.8905 77.9171 41.528 76.8976Z",
    fill: "url(#paint33_linear_5360_33364)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M60.6504 78.4359C59.0191 78.8664 57.8184 80.1805 57.4332 81.8344C57.2746 82.4688 57.0254 83.1031 56.7082 83.6695C56.7309 83.6469 56.7535 83.6016 56.7762 83.5563C57.116 86.1617 58.2488 90.3305 61.5113 96.0398C61.7832 96.5156 61.6246 97.1273 61.1488 97.3992L58.4074 99.0531C57.9316 99.3477 57.3199 99.1891 57.0254 98.7133L50.0246 86.9773C47.9855 86.7281 46.0824 85.55 44.9723 83.6016L44.927 83.5336C44.0887 82.0383 42.8199 80.8148 41.302 79.9766C41.3246 79.9992 41.3699 79.9992 41.3926 80.0219C39.3309 78.8891 37.5184 77.2805 36.023 75.4227L34.7316 75.8984C32.5113 76.7367 30.1098 76.2609 28.3652 74.8789C28.6824 75.2414 53.0832 99.6648 65.0231 111.582C67.4699 110.676 69.1918 108.32 69.1918 105.578V77.0086C66.3371 77.2805 63.4598 77.7563 60.6504 78.4359Z",
    fill: "url(#paint34_linear_5360_33364)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5360_33364",
    x1: 11.3269,
    y1: 1.18173,
    x2: 69.8201,
    y2: 116.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5360_33364",
    x1: 9.95843,
    y1: 3.58578,
    x2: 12.976,
    y2: 6.32266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A4C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5360_33364",
    x1: 75.1528,
    y1: 3.03841,
    x2: 68.6362,
    y2: 6.64098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32365C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32365C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5360_33364",
    x1: 71.9671,
    y1: 115.578,
    x2: 67.0371,
    y2: 109.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5360_33364",
    x1: 40.4936,
    y1: 116.41,
    x2: 40.4936,
    y2: 112.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292C4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5360_33364",
    x1: 5.36805,
    y1: 118.46,
    x2: 13.9233,
    y2: 109.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A4C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5360_33364",
    x1: 74.2137,
    y1: 58.5008,
    x2: 70.1725,
    y2: 58.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32365C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32365C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5360_33364",
    x1: 40.4936,
    y1: -0.0974453,
    x2: 40.4936,
    y2: 4.13723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A4C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5360_33364",
    x1: 6.77409,
    y1: 58.5008,
    x2: 10.987,
    y2: 58.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A4C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5360_33364",
    x1: 13.4034,
    y1: 5.26728,
    x2: 67.7306,
    y2: 112.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5360_33364",
    x1: 69.3081,
    y1: 58.5023,
    x2: 65.2477,
    y2: 58.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000187801,
    stopColor: "#A1B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5360_33364",
    x1: 40.4928,
    y1: 111.979,
    x2: 40.4928,
    y2: 107.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000187801,
    stopColor: "#A1B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5360_33364",
    x1: 11.0766,
    y1: 58.5023,
    x2: 15.6847,
    y2: 58.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000211276,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5360_33364",
    x1: 40.4928,
    y1: 5.12795,
    x2: 40.4928,
    y2: 8.75997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000211276,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5360_33364",
    x1: 40.4928,
    y1: 104.774,
    x2: 40.4928,
    y2: 109.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5360_33364",
    x1: 40.4921,
    y1: 105.828,
    x2: 40.4921,
    y2: 108.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9093BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1833,
    stopColor: "#898CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#75789F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8134,
    stopColor: "#56597C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5360_33364",
    x1: 40.4928,
    y1: 7.58267,
    x2: 40.4928,
    y2: 13.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5360_33364",
    x1: 40.4921,
    y1: 8.21445,
    x2: 40.4921,
    y2: 12.7038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9093BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1833,
    stopColor: "#898CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#75789F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8134,
    stopColor: "#56597C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5360_33364",
    x1: 33.0545,
    y1: 8.56562,
    x2: 33.0545,
    y2: 11.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5360_33364",
    x1: 33.0549,
    y1: 9.13387,
    x2: 33.0549,
    y2: 11.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9093BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1833,
    stopColor: "#898CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#75789F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8134,
    stopColor: "#56597C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5360_33364",
    x1: 32.9686,
    y1: 9.88014,
    x2: 33.3916,
    y2: 10.6502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#B0B2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    stopColor: "#9A9DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6572,
    stopColor: "#777999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#46496A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5360_33364",
    x1: 73.0113,
    y1: 38.9862,
    x2: 74.4407,
    y2: 38.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9093BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5360_33364",
    x1: 6.2005,
    y1: 37.8392,
    x2: 7.38021,
    y2: 37.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9093BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5360_33364",
    x1: 53.8885,
    y1: 86.2782,
    x2: 59.6124,
    y2: 97.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5360_33364",
    x1: 75.6816,
    y1: 21.0577,
    x2: 104.815,
    y2: 82.4502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5360_33364",
    x1: 74.6946,
    y1: 53.5849,
    x2: 99.9517,
    y2: 45.0824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000133025,
    stopColor: "#FF941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2962,
    stopColor: "#FFAD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7497,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5360_33364",
    x1: 51.9756,
    y1: 42.7528,
    x2: 62.8538,
    y2: 76.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7038,
    stopColor: "#FFAD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5360_33364",
    x1: 37.5132,
    y1: 50.0975,
    x2: 51.1421,
    y2: 81.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1773,
    stopColor: "#FC5659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    stopColor: "#F3454F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    stopColor: "#E4293F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#CF0129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE0028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5360_33364",
    x1: 75.541,
    y1: 46.9154,
    x2: 83.2933,
    y2: 56.7516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1773,
    stopColor: "#FC5659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    stopColor: "#F3454F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6911,
    stopColor: "#E4293F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9899,
    stopColor: "#CF0129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE0028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5360_33364",
    x1: 27.5298,
    y1: 64.4546,
    x2: 33.0869,
    y2: 77.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6D6F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5360_33364",
    x1: 51.6432,
    y1: 80.7229,
    x2: 53.6995,
    y2: 85.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7038,
    stopColor: "#FFAD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5360_33364",
    x1: 38.876,
    y1: 65.2934,
    x2: 40.1264,
    y2: 68.6278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7038,
    stopColor: "#FFAD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5360_33364",
    x1: 37.7119,
    y1: 55.4561,
    x2: 38.8789,
    y2: 59.1654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7038,
    stopColor: "#FFAD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5360_33364",
    x1: 44.3868,
    y1: 73.7361,
    x2: 45.7206,
    y2: 77.2372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7038,
    stopColor: "#FFAD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5360_33364",
    x1: 40.8151,
    y1: 68.0066,
    x2: 73.1831,
    y2: 100.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1854,
    stopColor: "#A1B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8466,
    stopColor: "#A1B3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5360_33364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroPhoneDraftCampaign);
export default __webpack_public_path__ + "static/media/microPhoneDraftCampaign.7443b8730d9f8dc3493f06f8a1944e01.svg";
export { ForwardRef as ReactComponent };